import { render, staticRenderFns } from "./EmailsListContainer.vue?vue&type=template&id=2cb5ebba&scoped=true"
import script from "./EmailsListContainer.vue?vue&type=script&lang=js"
export * from "./EmailsListContainer.vue?vue&type=script&lang=js"
import style0 from "./EmailsListContainer.vue?vue&type=style&index=0&id=2cb5ebba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb5ebba",
  null
  
)

export default component.exports